import Vue from 'vue'
import Router from 'vue-router'
import LoginLayout from "./layout/LoginLayout";
import DashboardLayout from "./layout/DashboardLayout";
import Login from "./pages/Login";
import Dashboard from "./pages/Dashboard";
import Deals from "./pages/Deals";
import Billing from "./pages/Billing";
import EditDeal from "./pages/EditDeal";
import NotFoundPage from "./pages/NotFoundPage";

import Logout from "./pages/Logout";

Vue.use(Router);

const router = new Router({
  mode: 'history',
  linkActiveClass: 'nav-item active',
  scrollBehavior: (to) => {
    if (to.hash) {
      return {selector: to.hash}
    } else {
      return {x: 0, y: 0}
    }
  },
  routes: [
    {
      path: '',
      redirect: 'dashboard'
    },
    {
      path: '/dashboard',
      component: DashboardLayout,
      children: [
        {
          path: '/dashboard',
          name: 'Dashboard',
          component: Dashboard
        },
        {
          path: '/billing/:id',
          name: 'Billing',
          component: Billing
        },
        {
          path: '/deals',
          name: 'Deals',
          component: Deals
        },
        {
          path: '/deal/',
          name: 'Add new deal',
          component: EditDeal
        },
        {
          path: '/deal/:id?',
          title: 'Edit deal',
          component: EditDeal
        }
      ]
    },
    {
      path: '/login',
      component: LoginLayout,
      children: [
        {
          path: '/login',
          name: 'Login',
          component: Login
        }
      ]
    },
    {
      path: '/logout',
      component: Logout,
    },
    {path: '*', component: NotFoundPage},

  ]
});

export default router;
